import actionTypes from '../constants/action-types';

const isLoaded = (state = false, action) => {
  if (action.type !== actionTypes.SET_LOADING_STATUS) return state;

  return action.payload.isLoaded;
};

export default isLoaded;
